import { itx } from "../../translationItx/itx";

export default function getRoomOptionsList(): Array<[string, string]> {
  // has to be in function because of itx translation
  const roomOptions: Array<[string, string]> = [
    [itx("step2.corridor", "Flur"), itx("step2.corridorTag", "F")],
    [itx("step2.bedroom", "Schlafen"), itx("step2.bedroomTag", "SC")],
    [itx("step2.livingRoom", "Wohnen"), itx("step2.livingRoomTag", "WO")],
    [itx("step2.loftarea"), itx("step2.loftareaTag")],
    [itx("step2.diningRoom", "Essen"), itx("step2.diningRoomTag", "ES")],
    [itx("step2.kitchen", "Küche"), itx("step2.kitchenTag", "KÜ")],
    [itx("step2.office", "Büro"), itx("step2.officeTag", "BÜ")],
    [itx("step2.nursery", "Kind"), itx("step2.nurseryTag", "KI")],
    [itx("step2.toilet", "WC"), itx("step2.toiletTag", "WC")],
    [itx("step2.bathroom", "Bad"), itx("step2.bathroomTag", "BA")],
    [itx("step2.guestRoom", "Gästezimmer"), itx("step2.guestRoomTag", "GZ")],
    [itx("step2.guestBathroom", "Gästebad"), itx("step2.guestBathroomTag", "GB")],
    [itx("step2.guestToilet", "Gäste WC"), itx("step2.guestToiletTag", "GWC")],
    [itx("step2.storageRoom", "Abstellraum"), itx("step2.storageRoomTag", "A")],
    [itx("step2.heatingRoom", "Heizung"), itx("step2.heatingRoomTag", "HE")],
    [itx("step2.housWiringRoom", "Hausanschlußraum"), itx("step2.housWiringRoomTag", "HA")],
  ];
  const res = roomOptions.sort();
  return res;
}
